import { Dayjs } from 'dayjs'

import { ModeEnum, PmsiTypeEnum, PrivacyEnum, SearchGroupPrivacyEnum, User } from '@/store/modules/settings/types'
import { HospitalizationType } from '@/store/modules/stay/smr/types'
import { StayStatusEnum } from '@/store/modules/stay/types'

type SavedSearchUser = Pick<User, 'id' | 'username' | 'team'>

/**
 * Used when search is being created or is unknown
 */
export const DEFAULT_SEARCH_ID = -1

export type ListedSavedSearch = {
  id: number
  reference: string
  name: string
  searchOperators: SearchOperatorEnum
  isAdvancedSearch: boolean
  countTodoStay: number
  privacy: PrivacyEnum
  savedSearchCategory: SavedSearchCategory
  user: SavedSearchUser
  validated: boolean
  disabled: boolean
  toBeRemoved: boolean
  type: ModeEnum
  pmsiType: PmsiTypeEnum
}

export interface SearchGroup {
  id: number
  reference: string
  name: string
  pmsiType: PmsiTypeEnum
  type: ModeEnum
  privacy: SearchGroupPrivacyEnum
  savedSearches: ListedSavedSearch[]
  countTodoStay: number
}
export enum SearchOperatorEnum {
  AND_OR = 'andOr',
  OR_AND = 'orAnd',
}

export type SavedSearchCategory = {
  id: number | null
  name: string
}

export type StoredSavedSearchCategory = SavedSearchCategory & {
  countStay: number
  countTodoStay: number
}

export enum RevaluationTypeEnum {
  UNDETERMINED = 'undetermined',
  SEARCH_DAS = 'search_das',
  SEARCH_DP = 'search_dp',
  IA_DAS = 'ia_das',
  IA_DP = 'ia_dp',
  IA_AND_SEARCH_DAS = 'ia_and_search_das',
  IA_AND_SEARCH_DP = 'ia_and_search_dp',
  IA_OR_SEARCH_DP = 'ia_or_search_dp',
  IA_OR_SEARCH_DAS = 'ia_or_search_das',
  IA_OR_SEARCH_DAS_OR_DP = 'ia_or_search_das_or_dp',
  CHRONIC_DAS = 'chronic_das',
}

export interface StayListUrlParams {
  mode: ModeEnum
  el: string
  ll: string
  mu?: number[]
  hospitalizationTypes?: HospitalizationType[]
  newCoding?: boolean
  sss?: StayStatusEnum[]
  revaluationType?: RevaluationTypeEnum
  searchId?: number[]
  edit?: number
}

export interface SavedSearchesPayload {
  mode?: string
  earlyLimit: Dayjs
  lateLimit: Dayjs
  unit?: string
  medicalUnits: number[] | null
  pmsiType?: PmsiTypeEnum
  searchMode?: ModeEnum
  searchIds?: number[]
  groupIds?: number[]
  hospitalizationTypes?: HospitalizationType[]
}
